import SwipeSdk, { SwipeSDK } from './lib/app/swipeSdk';
import LogiSdk from './lib/app/logiSdk';

/**
 * Expose SwipSDK globally (temporary backward compatibility)
 */
declare global {
  interface Window {
    SwipeSDK: SwipeSDK;
  }
}

window.SwipeSDK = SwipeSdk;

/**
 * Export LogiSDK library
 */
export default LogiSdk;
